import { render } from "./ParameterDoc.vue?vue&type=template&id=1c76b067&scoped=true"
import script from "./ParameterDoc.vue?vue&type=script&lang=js"
export * from "./ParameterDoc.vue?vue&type=script&lang=js"

import "./ParameterDoc.vue?vue&type=style&index=0&id=1c76b067&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c76b067"]])

export default __exports__